import React, { useState } from 'react';
import { HelpCircle, Clock, MessageCircle, Send, ExternalLink, ArrowRight, ChevronDown } from 'lucide-react';

// Telegram Icon
const TelegramIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
  </svg>
);

// FAQ Data - Частые вопросы о пополнении Alipay/Wechat
const faqItems = [
  {
    id: 1,
    question: 'Законно ли пополнение китайских кошельков через Kit8 Exchange?',
    answer: 'Да. Оплата производится на юридическое лицо в формате, согласованном с банком. Операция имеет понятный экономический смысл и соответствует требованиям финансового мониторинга.'
  },
  {
    id: 2,
    question: 'Почему в Kit8 нельзя оплатить переводом на карту физического лица?',
    answer: 'Переводы между частными лицами — одна из основных причин блокировок счетов. Kit8 использует безопасную модель приёма оплаты, которая исключает подобные риски.'
  },
  {
    id: 3,
    question: 'Что такое «белый треугольник» и почему это опасно для клиента?',
    answer: 'Это схема, при которой деньги клиента переводятся третьему лицу, не связанному напрямую с сервисом. Для банка такие операции выглядят как транзитные и потенциально подозрительные, а ответственность за перевод несёт клиент.'
  },
  {
    id: 4,
    question: 'Могут ли заблокировать мой счёт при пополнении через Kit8?',
    answer: 'При оплате на карты физических лиц риск блокировок высокий. При оплате на юридическое лицо, как в Kit8, этот риск существенно ниже.'
  },
  {
    id: 5,
    question: 'Зачем нужна верификация личности?',
    answer: 'Верификация необходима для работы в правовом поле, защиты клиента при возможных проверках и исключения участия в серых платёжных схемах.'
  },
  {
    id: 6,
    question: 'Сколько времени занимает обмен?',
    answer: 'Сделка стабильно проходит за 5–10 минут.'
  },
  {
    id: 7,
    question: 'Нужно ли общаться с оператором или поддержкой?',
    answer: 'Нет. Весь процесс полностью автоматизирован и проходит внутри Telegram-бота.'
  },
  {
    id: 8,
    question: 'Чем Telegram-бот Kit8 отличается от ботов других обменников?',
    answer: 'Мы предлагаем надёжный сервис, в котором безопасность и комфорт клиента являются приоритетом.'
  },
  {
    id: 9,
    question: 'Курс выше из-за безопасной модели оплаты?',
    answer: 'Нет. Курс сопоставим с минимальными предложениями на рынке, дополнительной комиссии «за безопасность» нет.'
  },
  {
    id: 10,
    question: 'Подходит ли Kit8 Exchange для регулярных пополнений Alipay?',
    answer: 'Да. Сервис изначально выстроен как стабильное решение для регулярных операций, а не как временный способ обмена.'
  },
  {
    id: 11,
    question: 'Как в Kit8 происходит зачисление юаней на Alipay и WeChat клиента?',
    answer: 'После получения оплаты операция передаётся в обработку платёжным партнёрам в Китае, которые специализируются на пополнении Alipay и WeChat. Зачисление юаней происходит напрямую на кошелёк клиента и, как правило, занимает 5–10 минут с момента подтверждения оплаты.'
  },
  {
    id: 12,
    question: 'С каким банком сотрудничает Kit8 Exchange для приёма оплаты?',
    answer: 'Для приёма платежей Kit8 использует банковскую инфраструктуру партнёра — Очамчыр Банк. Это позволяет выстроить безопасную и прозрачную модель приёма оплаты без переводов между частными лицами.'
  },
  {
    id: 13,
    question: 'Открывается ли банковский счёт на клиента при использовании Kit8 Exchange?',
    answer: 'Нет. Банковские счета на клиентов не открываются.'
  }
];

// FAQ Item Component
const FAQItem = ({ item, isOpen, onToggle }) => (
  <div className="border-b border-gray-700/50 last:border-b-0">
    <button
      onClick={onToggle}
      className="w-full flex items-center justify-between py-4 text-left"
    >
      <span className="text-gray-200 text-sm pr-4">{item.question}</span>
      <ChevronDown 
        className={`w-5 h-5 text-gray-500 flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} 
      />
    </button>
    <div 
      className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-4' : 'max-h-0'}`}
    >
      <p className="text-gray-400 text-sm leading-relaxed">{item.answer}</p>
    </div>
  </div>
);

const SupportScreen = () => {
  const [openFAQ, setOpenFAQ] = useState(null);

  const toggleFAQ = (id) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-900 to-black p-4 pb-8">
      <div className="max-w-md mx-auto pt-20">
        
        {/* Header Card */}
        <div className="bg-gray-800/50 rounded-2xl p-5 mb-4 border border-gray-700/50">
          <div className="flex items-center gap-4">
            <div className="bg-purple-500/20 rounded-xl p-3">
              <HelpCircle className="w-6 h-6 text-purple-400" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-white">Помощь</h1>
              <p className="text-gray-500 text-sm">Служба поддержки Kit8 Exchange</p>
            </div>
          </div>
        </div>

        {/* Info Cards */}
        <div className="bg-gray-800/50 rounded-2xl p-5 mb-4 border border-gray-700/50">
          <h2 className="text-sm font-medium text-gray-400 mb-4">Информация</h2>
          
          <div className="space-y-3">
            {/* Working Hours */}
            <div className="flex items-center justify-between py-3 border-b border-gray-700/50">
              <div className="flex items-center gap-3">
                <Clock className="w-5 h-5 text-green-400" />
                <span className="text-gray-300">Время работы</span>
              </div>
              <span className="text-white font-medium">24/7</span>
            </div>

            {/* Response Time */}
            <div className="flex items-center justify-between py-3 border-b border-gray-700/50">
              <div className="flex items-center gap-3">
                <MessageCircle className="w-5 h-5 text-blue-400" />
                <span className="text-gray-300">Время ответа</span>
              </div>
              <span className="text-white font-medium">5-15 мин</span>
            </div>

            {/* Telegram Channel */}
            <button
              onClick={() => window.open('https://t.me/kit8exchange', '_blank')}
              className="w-full flex items-center justify-between py-3 group"
            >
              <div className="flex items-center gap-3">
                <TelegramIcon className="w-5 h-5 text-sky-400" />
                <span className="text-gray-300 group-hover:text-white transition-colors">Telegram канал</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-sky-400 font-medium">@kit8exchange</span>
                <ExternalLink className="w-4 h-4 text-gray-500 group-hover:text-sky-400 transition-colors" />
              </div>
            </button>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="bg-gray-800/50 rounded-2xl p-5 mb-4 border border-gray-700/50">
          <h2 className="text-sm font-medium text-gray-400 mb-1">Частые вопросы</h2>
          <p className="text-xs text-gray-500 mb-3">О пополнении Alipay и WeChat</p>
          
          <div>
            {faqItems.map((item) => (
              <FAQItem
                key={item.id}
                item={item}
                isOpen={openFAQ === item.id}
                onToggle={() => toggleFAQ(item.id)}
              />
            ))}
          </div>
        </div>

        {/* Contact Support Button */}
        <button
          onClick={() => window.open('https://t.me/kit8exchange_support', '_blank')}
          className="w-full bg-purple-600 hover:bg-purple-500 text-white rounded-2xl py-4 px-5 font-medium transition-all flex items-center justify-between"
        >
          <div className="flex items-center gap-3">
            <Send className="w-5 h-5" />
            <span>Написать в поддержку</span>
          </div>
          <ArrowRight className="w-5 h-5" />
        </button>

        {/* Footer Note */}
        <p className="text-center text-xs text-gray-600 mt-4 px-4">
          Мы отвечаем на все обращения в порядке очереди
        </p>
      </div>
    </div>
  );
};

export default SupportScreen;
